import { render, staticRenderFns } from "./CardHistoricoEmails.vue?vue&type=template&id=72b99589"
import script from "./CardHistoricoEmails.vue?vue&type=script&lang=js"
export * from "./CardHistoricoEmails.vue?vue&type=script&lang=js"
import style0 from "./CardHistoricoEmails.vue?vue&type=style&index=0&id=72b99589&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b99589')) {
      api.createRecord('72b99589', component.options)
    } else {
      api.reload('72b99589', component.options)
    }
    module.hot.accept("./CardHistoricoEmails.vue?vue&type=template&id=72b99589", function () {
      api.rerender('72b99589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardHistoricoEmails.vue"
export default component.exports